// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.tank_health_enum */
var TankHealthEnum;
(function (TankHealthEnum) {
    TankHealthEnum["GOOD"] = "GOOD";
    TankHealthEnum["WATCH"] = "WATCH";
    TankHealthEnum["PROBLEM"] = "PROBLEM";
})(TankHealthEnum || (TankHealthEnum = {}));
;
export default TankHealthEnum;
/** Zod schema for tank_health_enum */
export const tankHealthEnum = z.nativeEnum(TankHealthEnum);
//# sourceMappingURL=TankHealthEnum.js.map